import React from 'react'
import { TextField, BooleanField } from 'react-admin'
import { ListGuesser } from 'theme/components'

export const SurgeryTypeOptionStoreList = (props) => (
  <ListGuesser
    {...props}
    filter={{
      properties: ['id', 'name', 'enabledInPortal'],
      'properties[store]': ['name'],
      'properties[surgeryType]': ['name'],
    }}
    rowClick="edit"
  >
    <TextField
      source="originId"
      label="id"
      sortBy="id"
      sort={{ field: 'id', order: 'DESC' }}
    />
    <TextField source="surgeryType.name" label="Surgery type" />
    <TextField source="name" label="Translated surgery type" />
    <TextField source="store.name" label="Store" />
    <BooleanField source="enabledInPortal" />
  </ListGuesser>
)
